import { createContext, useContext } from "react";
const ThemeContext = createContext(null);
const useTheme = () => {
  const themeContext = useContext(ThemeContext);
  if (themeContext === null) {
    throw new Error("No theme available on context");
  }
  return themeContext;
};
export {
  ThemeContext,
  useTheme
};
